import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import axiosInstance from "services/axiosInstance";
import { CampaignReportingResponse } from "services/apiService";
import { Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid } from "@mui/material";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const columns: GridColDef[] = [
    { field: "user_id", headerName: "Client_id", width: 90 },
    {
        field: "Year_Month",
        headerName: "Year_Month",
        width: 90,
        editable: true,
    },
    {
        field: "max_volume",
        headerName: "Max volume",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "volume",
        headerName: "Volume",
        type: "number",
        width: 60,
        editable: true,
    },
    {
        field: "cm_recipients",
        headerName: "Recipients",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "cm_messages",
        headerName: "Messages",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "cm_delivered",
        headerName: "Delivered",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "cm_rejected",
        headerName: "Rejected",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "cm_failed",
        headerName: "Failed",
        type: "number",
        width: 60,
        editable: true,
    },
    {
        field: "prc_failed_router",
        headerName: "Taux failed",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "failed_to_facture",
        headerName: "Failed to facture",
        type: "number",
        width: 120,
        editable: true,
    },
    {
        field: "failed_more_than_10",
        headerName: "Failed more than 10%",
        type: "number",
        width: 150,
        editable: true,
    },
    {
        field: "cm_converted",
        headerName: "Converted",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "cm_optout",
        headerName: "Optout",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "cm_price",
        headerName: "Amount",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "routing_cost_calculated",
        headerName: "Routing cost calculated",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "revenue",
        headerName: "Revenue",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "margin",
        headerName: "Margin",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "total_revenue",
        headerName: "Total Revenue",
        type: "number",
        width: 90,
        editable: true,
    },
    {
        field: "global_margin",
        headerName: "Global margin",
        type: "number",
        width: 90,
        editable: true,
    },
];

function Reporting() {
    const [campaignsReporting, setCampaignsReporting] = useState<
        CampaignReportingResponse[] | null
    >();
    const rows = campaignsReporting ?? [];
    const rowsWithId = rows?.map((row, index) => ({
        ...row,
        id: `row-${index}`,
    }));
    const [showFilterMonth, setShowFilterMonth] = useState(false);
    const [showFilterDateRange, setShowFilterDateRange] = useState(false);
    const [yearMonth, setYearMonth] = useState<Date>(new Date());
    const [startDate, setStartDate] = useState<Date>(new Date());
    const [endDate, setEndDate] = useState<Date>(new Date());
    const [month, setMonth] = useState<String>();
    const [year, setYear] = useState<String>();
    const handleYearMonthChange = (date: any) => {
        console.log("*** handleYearMonthChange function ***");
        setYearMonth(date);
    };

    const getCampaignsReportingMonth = (yearMonth: Date) => {
        console.log("getCampaignsReportingMonth function");
        let year = String(yearMonth.getFullYear());
        let month = String(yearMonth.getMonth() + 1);
        console.log(`year : ${year} - month : ${month}`);
        // call api method
        (async () => {
            try {
                console.log(`call api campaign api`);

                const response = await axiosInstance.get<CampaignReportingResponse[]>(
                    process.env.REACT_APP_API_CAMPAGNES_REPORTING_MONTH?.replace(
                        ":year",
                        year
                    ).replace(":month", month) as string
                );
                console.log(`Campaing reporting res : ${response.data}`);
                setCampaignsReporting(response.data);
            } catch (error) {
                console.log(`Error while calling GetCostMessage:`, error);
            }
        })();
    };

    const getCampaignsReportingDateRange = (startDate: Date, endDate: Date) => {
        console.log(`getCampaignsReportingDateRange function`);
        let startDateFormatted = startDate.toISOString().substring(0, 10);
        let endDateFormatted = endDate.toISOString().substring(0, 10);
        // call api method
        (async () => {
            try {
                console.log(`call api campaign api`);

                const response = await axiosInstance.get<CampaignReportingResponse[]>(
                    process.env.REACT_APP_API_CAMPAGNES_REPORTING_DATE_RANGE?.replace(
                        ":start_date",
                        startDateFormatted
                    ).replace(":end_date", endDateFormatted) as string
                );
                console.log(`Campaing reporting res : ${response.data}`);
                setCampaignsReporting(response.data);
            } catch (error) {
                console.log(`Error while calling GetCostMessage:`, error);
            }
        })();
    };

    const exportCSVReportingMonth = (yearMonth: Date) => {
        console.log("getCampaignsReportingMonth function");
        let year = String(yearMonth.getFullYear());
        let month = String(yearMonth.getMonth() + 1);
        console.log(`year : ${year} - month : ${month}`);
        // call api method

        axios
            .get(
                `http://127.0.0.1:8000/api/campagnes/reporting/export_csv/?year=${year}&month=${month}`,
                {
                    responseType: "blob",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement("a");
                a.href = url;
                a.download = "export.csv";
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Erreur lors de l'export :", error);
            });
    };

    const exportCSVReportingDateRange = (startDate: Date, endDate: Date) => {
        console.log(`getCampaignsReportingDateRange function`);
        let startDateFormatted = startDate.toISOString().substring(0, 10);
        let endDateFormatted = endDate.toISOString().substring(0, 10);
        // call api method
        axios
            .get(
                `http://127.0.0.1:8000/api/campagnes/reporting/export_csv?start_date=:${startDateFormatted}&end_date=:${endDateFormatted}`,
                {
                    responseType: "blob",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement("a");
                a.href = url;
                a.download = "export.csv";
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Erreur lors de l'export :", error);
            });
    };

    const handleClickFilterData = () => {
        if (showFilterMonth) {
            getCampaignsReportingMonth(yearMonth);
        } else {
            getCampaignsReportingDateRange(startDate, endDate);
        }
    };

    const handleExportFilteredData = () => {
        console.log("** handleExportFilteredData **");
        if (showFilterMonth) {
            exportCSVReportingMonth(yearMonth);
        } else {
            exportCSVReportingDateRange(startDate, endDate);
        }
    };

    useEffect(() => {
        (async () => {
            try {
                console.log(`call api campaign api`);

                const response = await axiosInstance.get<CampaignReportingResponse[]>(
                    process.env.REACT_APP_API_CAMPAGNES_REPORTING_DEFAULT as string
                );
                console.log(`Campaing reporting res : ${response.data}`);
                setCampaignsReporting(response.data);
            } catch (error) {
                console.log(`Error while calling GetCostMessage:`, error);
            }
        })();
    }, []);

    useEffect(() => {
        setMonth(String(yearMonth.getMonth()));
        setYear(String(yearMonth.getFullYear()));
    }, [yearMonth]);

    console.log("campaignsReporting : ", campaignsReporting);
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Divider>Filter data</Divider>
                </Grid>

                {/* year month filter */}
                <Grid item xs={2}>
                    <FormGroup style={{ marginTop: "4px" }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showFilterMonth}
                                    onChange={(event) => {
                                        setShowFilterMonth(event.target.checked);
                                        setShowFilterDateRange(false);
                                    }}
                                />
                            }
                            label="Year and month"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showFilterDateRange}
                                    onChange={(event) => {
                                        setShowFilterDateRange(event.target.checked);
                                        setShowFilterMonth(false);
                                    }}
                                />
                            }
                            label="Date range"
                        />
                    </FormGroup>
                </Grid>
                {showFilterMonth && (
                    <Grid item xs={8}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth size="medium">
                                {/* <InputLabel id="cspMultiSelect">Month and Year</InputLabel> */}

                                <DatePicker
                                    label={'"month" and "year"'}
                                    views={["month", "year"]}
                                    value={yearMonth}
                                    onChange={handleYearMonthChange}
                                    renderInput={(params: any) => <TextField {...params} />}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                )}

                {showFilterDateRange && (
                    <Grid item xs={8}>
                        <Grid container direction={"row"}>
                            <Grid xs={3}>
                                <FormControl size="small">
                                    <DatePicker
                                        label="Start date"
                                        value={startDate}
                                        inputFormat="dd/MM/yyyy"
                                        onChange={(newValue: any) => {
                                            setStartDate(newValue);
                                            console.log("startDate : ", startDate.toISOString());
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={3}>
                                <FormControl size="small">
                                    <DatePicker
                                        label="End date"
                                        value={endDate}
                                        inputFormat="dd/MM/yyyy"
                                        onChange={(newValue: any) => {
                                            setEndDate(newValue);
                                            console.log("endDate : ", endDate);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                )}

                {/* Export button */}
                {showFilterMonth || showFilterDateRange ? (
                    <Grid item xs={2}>
                        <Button variant="outlined" onClick={handleClickFilterData}> Filter </Button>
                        <Button style={{ marginLeft: 2 }} variant="outlined" onClick={handleExportFilteredData}> Export </Button>
                    </Grid>
                ) : null}
            </Grid>

            <DataGrid
                rows={rowsWithId}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
                style={{ marginTop: "20px", height: "440px" }}
                sx={{
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "lightblue",
                    },
                }}
            />
        </>
    );
}

export default Reporting;
